module.exports = __webpack_public_path__ + "media/images/payment/logo_711-78cbde21e40a5decafd4a1b8e82fe011.gif";